import type { HtmlFromDotcms } from '../converters-from-dotcms';
import {
  convertDotcmsResponseToRecord,
  wrapDotcmsHtml,
} from '../converters-from-dotcms';
import type { ILinkData } from '../dotcms-link';
import { LinkGqlHelper } from '../dotcms-link';
import { buildGqlFieldsQuery } from '../gql-builders';
import type { IGqlHelper } from '../gql-helper';
import type { IRelatedResourcesData } from './dotcms-article';
import { RelatedResourcesDataGqlHelper } from './related-resources-helpers';

export type IArticlesPreviewModuleData = IRelatedResourcesData & {
  header?: HtmlFromDotcms;
  description?: HtmlFromDotcms;
  articleLink?: ILinkData;
  button?: ILinkData;
};

export const ArticlesPreviewModuleGqlHelper: IGqlHelper<IArticlesPreviewModuleData> =
  {
    contentTypeName: 'ArticlesPreviewModule',
    gqlFieldsQuery: `
    header
    description
    articlelink { ${buildGqlFieldsQuery(LinkGqlHelper)} }
    button { ${buildGqlFieldsQuery(LinkGqlHelper)} }
    ${RelatedResourcesDataGqlHelper.gqlFieldsQuery}   
  `,
    processGqlData: (gqlResponse: unknown) => {
      const relatedResources =
        RelatedResourcesDataGqlHelper.processGqlData(gqlResponse);
      if (!gqlResponse || !relatedResources) {
        return undefined;
      }

      const {
        header, description, articlelink, button,
      } =
        convertDotcmsResponseToRecord(gqlResponse);

      return {
        header: wrapDotcmsHtml(header),
        description: wrapDotcmsHtml(description),
        articleLink: LinkGqlHelper.processGqlData(articlelink),
        button: LinkGqlHelper.processGqlData(button),
        ...relatedResources,
      };
    },
  };
